export default __webpack_public_path__ + "assets/6aeba786395e9a628a68cb074d141987.svg";